import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63433d10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-preview page" }
const _hoisted_2 = { class: "report-preview__main" }
const _hoisted_3 = { class: "report-preview__header" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-bold" }
const _hoisted_6 = { class: "text-bold" }
const _hoisted_7 = { class: "text-bold" }
const _hoisted_8 = { class: "text-bold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "report-preview__title" }, "Отчёт о гигиене полости рта", -1))
const _hoisted_10 = { class: "report-preview__survey" }
const _hoisted_11 = { class: "report-preview__survey-date" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-bold" }, "Дата обследования:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-bold" }, "ФИО врача:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-bold" }, "Должность:", -1))
const _hoisted_15 = { class: "report-preview__patient" }
const _hoisted_16 = { class: "report-preview__patient-about" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("ФИО пациента:")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Дата рождения:")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Мед карта:")
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "report-preview__images" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "report-preview__images-title" }, "Фотографии зубов", -1))
const _hoisted_23 = { class: "report-preview page" }
const _hoisted_24 = { class: "report-preview__main" }
const _hoisted_25 = { class: "report-preview__recommendations" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "report-preview__recommendations-title" }, "Рекомендации", -1))
const _hoisted_27 = { class: "report-preview__recommendations-content" }
const _hoisted_28 = { class: "report-preview__recommendations-hygiene" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report-preview__recommendations-hygiene-text" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mr-4" }, "1."),
  /*#__PURE__*/_createElementVNode("p", null, "Следующая профессиональная гигиена зубов:")
], -1))
const _hoisted_30 = { class: "report-preview__recommendations-hygiene-text" }
const _hoisted_31 = { class: "report-preview__recommendations-consultation" }
const _hoisted_32 = { class: "report-preview__recommendations-consultation-title" }
const _hoisted_33 = { class: "report-preview__recommendations-consultation-list-title" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "report-preview__recommendations-consultation-title" }
const _hoisted_36 = { class: "report-preview__recommendations-consultation-list-title" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "report-preview__comment-title" }, "Комментарий врача", -1))
const _hoisted_39 = { class: "report-preview__comment-text" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("ФИО врача:")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Должность:")
const _hoisted_42 = { class: "report-preview__footer" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "report-preview__footer-title" }, " Digitalized by DIANA™ — Dental Index Analysis Application "),
  /*#__PURE__*/_createElementVNode("p", { class: "report-preview__footer-text" }, " Результаты расчета не являются диагнозом или медицинской рекомендацией и не заменяют консультации с врачом. ")
], -1))
const _hoisted_44 = {
  key: 0,
  class: "report-preview page"
}
const _hoisted_45 = { class: "report-preview__main" }
const _hoisted_46 = { class: "report-preview__comment-text" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("ФИО врача:")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Должность:")
const _hoisted_49 = { class: "report-preview__footer" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "report-preview__footer-title" }, " Digitalized by DIANA™ — Dental Index Analysis Application "),
  /*#__PURE__*/_createElementVNode("p", { class: "report-preview__footer-text" }, " Результаты расчета не являются диагнозом или медицинской рекомендацией и не заменяют консультации с врачом. ")
], -1))

import { computed, onMounted, ref, watch, nextTick } from 'vue'
import {
  ConsultationType,
  ReportDetailType,
  ResultAnalyzesType,
  PatientType,
  CommentType,
  AppointmentType,
  ObservationHistoryType,
} from '@/shared/types'
import { getDateFormat, declination, showErrorMessage } from '@/shared/utils'
import { patientApi } from '@/shared/api'
import { useRoute } from 'vue-router'
import {
  CONSULTATIONS_MAP,
  DATE_FORMAT,
  MEASURES_MAP,
} from '@/shared/constants'
import { EObservationHistory } from '@/entities/EObservationHistory'
import { EResultAnalyzes } from '@/entities/EResultAnalyzes'
import { WReportImages } from '@/widgets/WReportImages'
import WDentalCard from '@/widgets/WDentalCard'
import { PlaqueReportController } from '../plaqueReport'


export default /*#__PURE__*/_defineComponent({
  props: {
    reportInfo: null,
    resultAnalyzes: null,
    consultation: null,
    comments: null,
    plaqueReportController: null,
    appointments: null,
    observationHistory: null
  },
  setup(__props: any) {

const props = __props as {
  reportInfo: ReportDetailType
  resultAnalyzes: ResultAnalyzesType
  consultation: ConsultationType
  comments: CommentType[]
  plaqueReportController: PlaqueReportController
  appointments: AppointmentType
  observationHistory: ObservationHistoryType[]
}



const route = useRoute()
const consultations = computed(() => {
  return props.consultation.consultations.filter((consultation) =>
    CONSULTATIONS_MAP.has(consultation)
  )
})
const measures = computed(() => {
  return props.consultation.consultations.filter((consultation) =>
    MEASURES_MAP.has(consultation)
  )
})
const maxEnabled = computed(() => process.env.VUE_APP_MAX_ENABLE === 'true')

const patientInfo = ref<PatientType>({
  cart_number: '',
  date: '',
  id: 0,
  name: '',
  email: '',
  patronymic: '',
  phone: '',
  surname: '',
})

const logo = computed(() => {
  let domain = window.origin

  if (process.env.NODE_ENV === 'production') {
    domain = process.env.VUE_APP_BASE_URI
  }

  return props.reportInfo.organization?.logo
    ? `${domain}/api/web/admin/reports/storage/${props.reportInfo.organization?.logo.id}`
    : ''
})

const qrCodeEnabled = computed(
  () =>
    props.reportInfo.organization?.qr_codes_enabled &&
    props.reportInfo.organization?.telegram_enabled &&
    maxEnabled.value
)

const qrCode = computed(() => {
  let domain = window.origin

  if (process.env.NODE_ENV === 'production') {
    domain = process.env.VUE_APP_BASE_URI
  }

  return `${domain}/api/web/admin/reports/${reportId.value}/get-qr`
})

const patientId = computed<string | string[]>(() => route.params.patientId)
const reportId = computed<string | string[]>(() => route.params.reportId)

const date = computed(() =>
  props.reportInfo.date_at
    ? getDateFormat(new Date(props.reportInfo.date_at), DATE_FORMAT.dmyLong)
    : ''
)
const dateWithRecleaning = computed(() =>
  props.reportInfo.date_at
    ? getDateFormat(
        addMonth(
          new Date(props.reportInfo.date_at),
          props.consultation.reCleaning
        ),
        DATE_FORMAT.ymdDash
      )
    : ''
)

function addMonth(date, monthsCount = 1) {
  return new Date(new Date(date).setMonth(date.getMonth() + monthsCount))
}

const birthday = computed(() => patientInfo.value.date)

const commentsCurrentPage = ref<CommentType[]>([])
const commentsNextPage = ref<CommentType[]>([])
const commentsRef = ref<HTMLDivElement>()

const haveContentForNextPage = ref(false)

async function getCommentsCurrentPage() {
  return JSON.parse(JSON.stringify(props.comments))
}

async function allocationComments() {
  const MAX_HEIGHT_CONTENT = 400
  commentsCurrentPage.value = await getCommentsCurrentPage()

  commentsNextPage.value = []
  haveContentForNextPage.value = false
  await nextTick()

  while (commentsRef.value?.clientHeight > MAX_HEIGHT_CONTENT) {
    haveContentForNextPage.value = true
    commentsNextPage.value.push(commentsCurrentPage.value.pop())
    await nextTick()
  }
}

const signature = computed(() =>
  declination(props.consultation.reCleaning, ['месяц', 'месяца', 'месяцев'])
)

const getPatientInfo = async (): Promise<void> => {
  const [error, response] = await patientApi.getPatientInfo(
    Number(patientId.value)
  )

  if (error) {
    showErrorMessage(error)
  } else {
    patientInfo.value = response.data.patient
  }
}

watch([reportId, () => props.comments], async () => {
  await allocationComments()
})

onMounted((): void => {
  getPatientInfo()
  allocationComments()
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_icon_template = _resolveComponent("icon-template")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "report-preview__logo",
            src: _unref(logo)
          }, null, 8, _hoisted_4),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(__props.reportInfo.organization?.name), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(__props.reportInfo.organization?.address), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(__props.reportInfo.organization?.phone), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(__props.reportInfo.organization?.site), 1)
          ])
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, [
            _hoisted_12,
            _createTextVNode("  " + _toDisplayString(_unref(date)), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("p", null, [
              _hoisted_13,
              _createTextVNode("  " + _toDisplayString(__props.reportInfo.doctor?.name), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_14,
              _createTextVNode("  " + _toDisplayString(__props.reportInfo.doctor?.position), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_el_row, { class: "report-preview__patient-item" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 5,
                  class: "text-bold"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 19 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(patientInfo.value.surname) + " " + _toDisplayString(patientInfo.value.name) + " " + _toDisplayString(patientInfo.value.patronymic ?? ''), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "report-preview__patient-item" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 5,
                  class: "text-bold"
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 19 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(birthday)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "report-preview__patient-item" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 5,
                  class: "text-bold"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 19 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(patientInfo.value.cart_number), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          (_unref(qrCodeEnabled))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "report-preview__patient-qr-code",
                alt: "qr",
                src: _unref(qrCode),
                onerror: "this.style.display='none'"
              }, null, 8, _hoisted_20))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_unref(WReportImages), {
            images: __props.reportInfo.images,
            preview: ""
          }, null, 8, ["images"])
        ]),
        _createVNode(_unref(EResultAnalyzes), {
          plaqueReportController: __props.plaqueReportController,
          "result-analyzes": __props.resultAnalyzes
        }, null, 8, ["plaqueReportController", "result-analyzes"])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_unref(EObservationHistory), { "observation-history": __props.observationHistory }, null, 8, ["observation-history"]),
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("p", _hoisted_30, _toDisplayString(_unref(dateWithRecleaning)) + " (через " + _toDisplayString(__props.consultation.reCleaning) + " " + _toDisplayString(_unref(signature)) + ") ", 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("p", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, [
                  _createTextVNode(" 2. Консультация врачей: " + _toDisplayString(_unref(consultations)
                    .map((consultation) => _unref(CONSULTATIONS_MAP).get(consultation))
                    .join(', ')) + " ", 1),
                  (!_unref(consultations).length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, "-"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("p", _hoisted_35, [
                _createElementVNode("span", _hoisted_36, [
                  _createTextVNode(" 3. Мероприятия для оценки десен и обучения: " + _toDisplayString(_unref(measures)
                    .map((measure) => _unref(MEASURES_MAP).get(measure))
                    .join(', ')) + " ", 1),
                  (!_unref(measures).length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, "-"))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        (commentsCurrentPage.value.length)
          ? (_openBlock(), _createBlock(_component_el_divider, { key: 0 }))
          : _createCommentVNode("", true),
        (commentsCurrentPage.value.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              ref_key: "commentsRef",
              ref: commentsRef
            }, [
              _hoisted_38,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentsCurrentPage.value, (comment, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "report-preview__comment"
                }, [
                  _createElementVNode("p", _hoisted_39, [
                    _createTextVNode(_toDisplayString(comment.text) + " ", 1),
                    (comment.files.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(`(${comment.files.length})`), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_row, { class: "report-preview__comment-doctor" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 3,
                        class: "text-bold"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_40
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 21 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(comment.user_name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_row, { class: "report-preview__comment-doctor" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 3,
                        class: "text-bold"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_41
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 21 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(comment.user_position), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_42, [
        _hoisted_43,
        _createVNode(_component_icon_template, {
          name: "logo",
          width: "92",
          height: "28"
        })
      ])
    ]),
    (haveContentForNextPage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentsNextPage.value, (comment, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "report-preview__comment"
              }, [
                _createElementVNode("p", _hoisted_46, [
                  _createTextVNode(_toDisplayString(comment.text) + " ", 1),
                  (comment.files.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Document)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(`(${comment.files.length})`), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_row, { class: "report-preview__comment-doctor" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 3,
                      class: "text-bold"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_47
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 21 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(comment.user_name), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_row, { class: "report-preview__comment-doctor" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 3,
                      class: "text-bold"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_48
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 21 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(comment.user_position), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createVNode(_component_icon_template, {
              name: "logo",
              width: "92",
              height: "28"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(WDentalCard), {
      "plaque-report-controller": __props.plaqueReportController,
      class: "page",
      "result-analyzes": __props.resultAnalyzes,
      appointments: __props.appointments,
      "observation-history": __props.observationHistory
    }, null, 8, ["plaque-report-controller", "result-analyzes", "appointments", "observation-history"])
  ], 64))
}
}

})